// src/components/Logo.jsx
import React from 'react';

const Logo = ({ isDarkMode }) => {
  const logoUrl = isDarkMode
    ? 'https://www.unframed.nl/app/uploads/2025/01/unframed-ai-darkmode.png'
    : 'https://www.unframed.nl/app/uploads/2025/01/unframed-ai.png';

  return (
    <div className={`w-full h-16 flex items-center justify-center mt-10 mb-5 ${isDarkMode ? 'bg-[#282828]' : 'bg-white'}`}>
      <img 
        src={logoUrl} 
        alt="Unframed AI" 
        className="w-48 object-contain"
      />
    </div>
  );
};

export default Logo;